import i18n from '../i18n';

export const sources = {
    linkedin: 'LinkedIn',
    other: i18n.t('commons__other', { ns: 'candidateProfile' }),
    unknown: i18n.t('commons__unknown'),
};
